import { Box, Button, InputText, Modal, Tooltip } from '@driftt/dds'
import React, { useState } from 'react'

import { ReducedScenarioEntity } from 'api/scenarios'

const ModifyNameConfiramtionModal = ({
  isOpen,
  onClose,
  onAction,
  scenarioCurrentName,
  scenarioId,
  possibleScenarios,
}: {
  isOpen: boolean
  onClose: () => void
  onAction: (newScenarioName?: string) => void
  scenarioCurrentName?: string
  scenarioId?: string
  possibleScenarios?: ReducedScenarioEntity[]
}) => {
  const [newScenarioName, setNewScenarioName] = useState<string>('')

  const nameConflict = possibleScenarios?.find(
    (scenario) =>
      scenario &&
      scenario.name === newScenarioName &&
      scenario.scenarioId !== scenarioId
  )

  return (
    <Modal.Root open={isOpen} onClose={onClose}>
      <Modal.Dialog fullWidth size="medium" variant={'warning'}>
        <Modal.Title
          title={`Update scenario name?`}
          subtitle={'The current scenario name is:\n' + scenarioCurrentName}
        />
        <Modal.Content>
          <Box css={{ marginBottom: '$1' }}>
            <InputText
              label="New scenario name:"
              placeholder={scenarioCurrentName}
              value={newScenarioName}
              onChange={(e) => setNewScenarioName(e.target.value)}
            />
          </Box>
        </Modal.Content>
        <Modal.Actions>
          <Button variant="secondary" onClick={onClose}>
            Skip
          </Button>
          <Tooltip
            content={
              nameConflict &&
              `This name is already in use. Please choose a different one.`
            }
            side="left"
          >
            <Button
              variant="primary"
              onClick={() => onAction(newScenarioName)}
              disabled={!newScenarioName || !!nameConflict}
            >
              Update
            </Button>
          </Tooltip>
        </Modal.Actions>
      </Modal.Dialog>
    </Modal.Root>
  )
}

export default ModifyNameConfiramtionModal
